/**
 * Air Quality Utility
 * Maps US AQI categories (from BE) to EPA band colors
 */

import type { AirQualityCategory } from '../types/weather.types';

// US EPA AQI band colors
export const AQI_CATEGORY_COLORS: Record<AirQualityCategory, string> = {
  good: '#22c55e',
  moderate: '#eab308',
  unhealthy_for_sensitive_groups: '#f97316',
  unhealthy: '#ef4444',
  very_unhealthy: '#a855f7',
  hazardous: '#7f1d1d',
};

// Neutral fallback when BE returns no category (upstream error / negative AQI)
export const DEFAULT_AQI_COLOR = '#6b7280';

/**
 * Get the card background color for an AQI category
 * @param category - US AQI category from BE (null when unavailable)
 * @returns Hex color string
 */
export function getAqiCategoryColor(category: AirQualityCategory | null | undefined): string {
  return (category && AQI_CATEGORY_COLORS[category]) || DEFAULT_AQI_COLOR;
}
